var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "4cd77a9f-ce7e-43e6-ac9d-d1a38eae5522"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "ea85adb2-65e9-47e8-9fad-8eb6389b8a70"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.36 0 0 2.36 540 540)",
    id: "3f41ba74-f38f-4a14-98a9-71821638264a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-192.2, -255.96)",
    d: "M 318.7 268.7 C 318.5 232 335.09999999999997 204.29999999999998 368.7 183.89999999999998 C 349.9 156.99999999999997 321.5 142.2 284 139.29999999999998 C 248.5 136.49999999999997 209.7 159.99999999999997 195.5 159.99999999999997 C 180.5 159.99999999999997 146.1 140.29999999999998 119.1 140.29999999999998 C 63.3 141.2 4 184.8 4 273.5 Q 4 312.8 18.4 354.7 C 31.2 391.4 77.4 481.4 125.6 479.9 C 150.79999999999998 479.29999999999995 168.6 462 201.39999999999998 462 C 233.2 462 249.7 479.9 277.79999999999995 479.9 C 326.4 479.2 368.19999999999993 397.4 380.4 360.59999999999997 C 315.2 329.9 318.7 270.59999999999997 318.7 268.69999999999993 z M 262.09999999999997 104.5 C 289.4 72.1 286.9 42.6 286.09999999999997 32 C 261.99999999999994 33.4 234.09999999999997 48.4 218.19999999999996 66.9 C 200.69999999999996 86.7 190.39999999999995 111.2 192.59999999999997 138.8 C 218.69999999999996 140.8 242.49999999999997 127.4 262.09999999999997 104.50000000000001 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleWhite);
export default __webpack_public_path__ + "static/media/apple-white.d60212e7d913de9063860b0b49b4b555.svg";
export { ForwardRef as ReactComponent };